export default __webpack_public_path__ + "static/media/105.7baf2bb4.png";